import React from 'react';
import { useSelector } from 'react-redux';
import { selectLimitedAccess } from '@/features/credits/store-selectors';
import { AppWithLimitedAccess } from '@/containers/AppWithLimitedAccess';
import { PrivateDatasourceAppPage } from '@/containers/PrivateDatasourceAppPage';
import { useUpdateLatestQueryMeta } from '@/features/query-builder/queryBuilderSlice';
import {
  useAppInit,
  useIsOnAllowedPage,
  useResetSteps,
  useUpdatePageTitleWithDatasourceName,
} from './hooks';

const TrevorApp = () => {
  const isNotOnAllowedPage = !useIsOnAllowedPage();
  const isLimitedAccess = useSelector(selectLimitedAccess);

  useAppInit();
  useResetSteps();
  useUpdatePageTitleWithDatasourceName();
  useUpdateLatestQueryMeta();

  return isLimitedAccess && isNotOnAllowedPage ? (
    <AppWithLimitedAccess />
  ) : (
    <PrivateDatasourceAppPage />
  );
};

export default TrevorApp;
